// extracted by mini-css-extract-plugin
export default {"error":"Error_error__RIiLz","wizardResponse":"Error_wizardResponse__lhrOS","fadeInOpacity":"Error_fadeInOpacity__MPKyp","wizardQuestion":"Error_wizardQuestion__F8wwO"};